import { invariant } from "@searchui-searchforms/shared/utils";
import type { FormValues } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import type { OtherFieldGroup } from "@/entities/form-metadata";
import { Grid, type GridSpan } from "@/shared/components/Grid";
import type { PrefixObjectAccessor } from "@/shared/forms";
import styles from "./OtherFieldsGroup.module.scss";

interface OtherFieldsGroupProps {
    fieldGroup: OtherFieldGroup;
}

export const OtherFieldsGroup = ({ fieldGroup }: OtherFieldsGroupProps) => (
    <div className={styles.fieldGroupSpacing}>
        <Grid.Container>
            {fieldGroup.others.map((item) => {
                const fieldPath = `fields.${item.relation}${item.eventType}${item.assertion}`;
                const fieldMetadata = item.fields[0];

                invariant(!!fieldMetadata, "Field metadata is missing");

                return (
                    <Grid.Field
                        key={fieldPath}
                        spanDesktop={(fieldMetadata.features?.gridColumnSpan as GridSpan) ?? 12}
                        spanTablet={(fieldMetadata.features?.gridColumnSpan as GridSpan) ?? 12}
                        spanMobile={12}
                    >
                        <FieldComposer
                            fieldPath={`${fieldPath}.value` as PrefixObjectAccessor<FormValues, []>}
                            exactnessFieldPath={`${fieldPath}.isExact` as PrefixObjectAccessor<FormValues, []>}
                            fieldConfig={fieldToConfig(fieldMetadata)}
                        >
                            <FieldComposer.Label />
                            <FieldComposer.GenericField aria-label={fieldMetadata.label} />
                            <FieldComposer.Footer>
                                <FieldComposer.GenericExactness />
                                <FieldComposer.UsageText />
                            </FieldComposer.Footer>
                        </FieldComposer>
                    </Grid.Field>
                );
            })}
        </Grid.Container>
    </div>
);
